import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { MSpinner } from "components/Shared";
import { getIntegrationStatuses } from "requests/integrations/integrationStatusCheck";

import AppraisalPort from "components/Homeowner/CaseForms/Actions/OnHold/AppraisalPort";
import MuellerOnHold from "components/Homeowner/CaseForms/Actions/OnHold/Mueller/index";
import WestAmcOnHold from "components/Homeowner/CaseForms/Actions/OnHold/WestAMC";
import DwellingBlocks from "components/Homeowner/CaseForms/Actions/OnHold/DwellingBlocks/index";

type IntegrationStatusResponse = {
    appraisalPort: boolean;
    westAmc: boolean;
    dwellingBlocks: boolean;
};

const OnHold = ({
  caseHeader, sendMessage, openCaseActionTab, closeTab
}) => {
  const [isAppraisalPortIntegrated, setAppraisalPortIntegrated] = useState(false);
  const [isDwellingBlocksIntegrated, setDwellingBlocksIntegrated] = useState(false);
  const [isWestAmcIntegrated, setWestAmcIntegrated] = useState(false);
  const [gettingStatus, setGettingStatus] = useState(true);
  const mounted = useRef<boolean>(true);

  useEffect(() => {
  const customerNumber = caseHeader.policyInfo.customerInfo.customerNumber;
  const integrationsToCheck = ["appraisalPort", "westAmc", "dwellingBlocks"];

  getIntegrationStatuses(customerNumber, integrationsToCheck, (response: IntegrationStatusResponse) => {
    setAppraisalPortIntegrated(response.appraisalPort);
    setWestAmcIntegrated(response.westAmc);
    setDwellingBlocksIntegrated(response.dwellingBlocks);
    setGettingStatus(false);
  }, () => {
    setGettingStatus(false);
  }, mounted);

  return () => {
    mounted.current = false;
  };
}, []);

  if (gettingStatus) return <MSpinner />;

  if (isAppraisalPortIntegrated)
    return <AppraisalPort openCaseActionTab={openCaseActionTab} closeTab={closeTab} />;
  else if (isWestAmcIntegrated)
    return <WestAmcOnHold openCaseActionTab={openCaseActionTab} closeTab={closeTab} />;
  else if (isDwellingBlocksIntegrated)
    return (
      // Dwelling Blocks at this time does not have custom Integration for OnHold Status like the other ones do
      // So need to use the default with it
      <>
        <MuellerOnHold openCaseActionTab={openCaseActionTab} closeTab={closeTab} />
        <DwellingBlocks openCaseActionTab={openCaseActionTab} sendMessage={sendMessage} closeTab={closeTab} />
      </>
  );
  else
    return <MuellerOnHold openCaseActionTab={openCaseActionTab} closeTab={closeTab} />;
};

OnHold.propTypes = {
  caseHeader: PropTypes.object,
  openCaseActionTab: PropTypes.func,
  closeTab: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    caseHeader: state.caseForms.caseHeader,
  };
};

export default connect(mapStateToProps)(OnHold);
